/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Approche.css';
import Helmet from 'react-helmet';
import fetch from '../../core/fetch';
import HeightMatchingGroup from 'react-height-matching-group';

const title = 'Approche';

@withStyles(s)
export default class Approche extends Component {
    
	constructor(props) {
        super(props);

        this.state = {
            approche: [],
            loader: true,
        };

        
    }

    componentDidMount(){

        this.GetApproche();

    }

    async GetApproche(){
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{approche{id, slug, title, content}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.approche) throw new Error('Erreur sur le chargement de la page approche !');

        if(data){
            this.setState({ loader: false })
        }
        
        this.setState({ approche: data.approche })
    }

    render(){

        const appear = this.state.loader ? 'appear' : '';
        var titrePage = "L'approche<br />Prolifik";
        var background = {
            backgroundColor: '#008eef'
        }

	    return (
	        <div className={s.root}>
	            <Helmet title={title} meta={[{"name": "description", "content": "L' approche Prolifik, Attirer, Convertir, Entretenir, Planifier, Accompagner"}]}/>
                <div className={`spinner ${appear}`} style={background}></div>
	            <div id="approche" className={`approche`}>
                    <div className={`bgHeader`}></div>
                    <main role="main">
                        <div dangerouslySetInnerHTML={{ __html: this.state.approche.content }} />
                    </main>
                </div>
	        </div>
	    );
    }
}





// WEBPACK FOOTER //
// ./containers/approche/Approche.js